import { useRef, useMemo } from 'react';
import { getClassNames } from '../../../helpers/classHelpers';
import { useSeparatorsResizeHandler, useRowMinHeightResizeHandler, useSpacing } from '../Grid.helpers';
import { GridType, GridProps } from '../Grid.types';
import styles from "../Grid.module.scss";

export default function Wrapper<Type extends GridType>(props: GridProps<Type>) {
    const gridRef = useRef<HTMLDivElement>(null);

    useSeparatorsResizeHandler(gridRef);
    useRowMinHeightResizeHandler(gridRef);

    const gap = useSpacing(props, "gap");
    const { arrange, width } = props as GridProps<"cols">;

    const attributes = useMemo(() => {
        const extra = {
            arrange,
            width,
            scroll: props.scroll ? "" : undefined
        };
        return {
            ...extra,
            ...gap.attributes,
            className: getClassNames([
                props.type,
                props.className,
            ], styles),
            style: {
                ...props.style,
                ...gap.style,
            }
        };
    }, [gap, arrange, width, props.className, props.style, props.type, props.scroll]);


    return <div className={getClassNames([styles.outer, props.outerClassName])}>
        <div ref={gridRef} {...attributes}>
            {props.children}
        </div>
    </div>;
};
